import { createAction } from "@reduxjs/toolkit";

import { SET_TIMER } from "./../constants";

/* ------------    ACTIONS     ------------------ */

export const setTimer = createAction(SET_TIMER, (name: string, value: number | undefined) => ({
  payload: { name, value },
}));
